import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var __Array = {
    checkboxGroupOptions: '_checkboxGroup',
    tagsOptions: '_tags',
    validation: '_arrayType',
};
var __Boolean = { checkboxOptions: '_checkbox' };
var __Function = { description: '_description' };
var __Number = {
    minimum: 'google.protobuf.FloatValue',
    maximum: 'google.protobuf.FloatValue',
    multipleOf: 'google.protobuf.FloatValue',
};
var __Object = { validation: '_objectType' };
var __String = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
    phoneInputOptions: '_phoneInput',
    dateInputOptions: '_dateInput',
    timeInputOptions: '_timeInput',
    datePickerOptions: '_datePicker',
};
var _actionProviderSPIConfig = { actionConfig: '_actionSPIConfig' };
var _actionSPIConfig = { icon: '_wixCommonImage' };
var _address = { multilineAddressOptions: '_componentsMultilineAddress' };
var _adminConfigurableTextInput = {
    requiredSettings: 'google.protobuf.FieldMask',
    adminConfigurableSettings: 'google.protobuf.FieldMask',
};
var _andCondition = { conditions: '_conditionNode' };
var _appData = { components: '_component', pricingModels: '_pricingModel' };
var _appEmbedData = { image: '_media' };
var _appointment = { description: '_richContent' };
var _archiveAppRequest = {};
var _arrayItems = { data: '_dataItems', dataItem: '_dataItem' };
var _arrayOptions = {
    objectOptions: '_objectOptions',
    arrayOptions: '_arrayOptions',
};
var _arrayType = { items: '_arrayTypeArrayItems' };
var _arrayTypeArrayItems = {
    numberOptions: '_numberType',
    objectOptions: '_objectType',
};
var _audioData = { audio: '_media', coverImage: '_media' };
var _authenticatorConfig = { expectedInputs: '_expectedInputs' };
var _background = { image: '_media' };
var _backgroundImage = { media: '_media' };
var _billing = {
    monthlyPrice: 'DOUBLE',
    yearlyPrice: 'DOUBLE',
    oneTimePrice: 'DOUBLE',
    meteredBilling: '_meteredBilling',
};
var _breakPoint = { items: '_itemLayout' };
var _breakpointPresetStyleOverrides = {
    default: '_presetStyleOverrides',
    small: '_presetStyleOverrides',
};
var _bulkDeleteAutomationAppsRequest = {};
var _bulkDeleteAutomationAppsResponse = {};
var _checkbox = { label: '_richContent' };
var _checkboxGroup = {
    description: '_richContent',
    options: '_checkboxGroupOption',
    media: '_mediaItem',
};
var _checkboxGroupOption = { media: '_mediaItem' };
var _collection = { fields: '_dataComponentField' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _component = { compData: '_componentData' };
var _componentData = {
    widgetComponentData: '_widgetComponentData',
    widgetOutOfIframeData: '_widgetOutOfIframeComponentData',
    studioWidgetComponentData: '_studioWidgetComponentData',
    dataComponent: '_dataComponent',
    shippingLabelCarrier: '_shippingLabelCarrierSpiConfig',
    fictionalShippingProvider: '_shippingProviderConfig',
    automationsActionProvider: '_actionProviderSPIConfig',
    identityAuthenticator: '_authenticatorConfig',
    devCenterTestingComponent: '_devCenterTestingComponentData',
    multilingualTranslationSchema: '_multilingualTranslationSchema',
    formTemplate: '_formTemplate',
    functionsShopPriceProvider: '_functionsShopPriceSpiConfig',
    function: '__Function',
    papiProvider: '_pluginConfig',
    multilingualTranslationSchemaGroup: '_schemaGroup',
    editorReactComponent: '_editorReactComponent',
};
var _componentsMultilineAddress = { description: '_richContent' };
var _conditionNode = { and: '_andCondition', or: '_orCondition' };
var _createAppRequest = {};
var _createAppResponse = {};
var _cssCustomPropertyItem = { number: '_cssNumber' };
var _cssNumber = {
    minimum: 'google.protobuf.FloatValue',
    maximum: 'google.protobuf.FloatValue',
    multipleOf: 'google.protobuf.FloatValue',
};
var _dataComponent = { collections: '_collection' };
var _dataComponentField = {
    objectOptions: '_objectOptions',
    arrayOptions: '_arrayOptions',
};
var _dataItem = {
    number: '__Number',
    arrayItems: '_arrayItems',
    data: '_dataItems',
};
var _dataItems = { items: 'Map#_dataItem' };
var _dateInput = { description: '_richContent', media: '_mediaItem' };
var _datePicker = { description: '_richContent', media: '_mediaItem' };
var _dateTimeInput = { description: '_richContent', media: '_mediaItem' };
var _deleteAppDeprecatedRequest = {};
var _deleteAppDeprecatedResponse = {};
var _description = { representativeImage: '_wixCommonImage' };
var _design = { poll: '_pollDesign' };
var _devCenterTestingComponentData = {
    translatableMessageInOneOf: '_messageContainingTranslatables',
    translatableMessage: '_messageContainingTranslatables',
    mapOfTranslatableMessages: 'Map#_messageContainingTranslatables',
    translatableRichContent: '_richContent',
    nonTranslatableRichContent: '_richContent',
    richContentMap: 'Map#_richContent',
};
var _displayField = { richContentOptions: '_richContentOptions' };
var _donationInput = { description: '_richContent', media: '_mediaItem' };
var _dropdown = { description: '_richContent', media: '_mediaItem' };
var _editorElement = {
    data: 'Map#_dataItem',
    elements: 'Map#_elementItem',
    presets: 'Map#_presetItem',
    cssCustomProperties: 'Map#_cssCustomPropertyItem',
};
var _editorPresence = { presetsEditorPresence: '_presetEditorPresence' };
var _editorReactComponent = { editorElement: '_editorElement' };
var _elementItem = {
    inlineElement: '_inlineElement',
    refElement: '_refElement',
};
var _elementStyleDefaults = { elements: 'Map#_elementStyleDefaults' };
var _elementStyleOverrides = { elements: 'Map#_elementStyleOverrides' };
var _expectedInputs = {
    expectedStartInputs: '_predefinedExpectedInput',
    expectedVerifyInputs: '_predefinedExpectedInput',
};
var _field = { inputOptions: '_inputField', displayOptions: '_displayField' };
var _fileUpload = { description: '_richContent', media: '_mediaItem' };
var _fixedPayment = { description: '_richContent', media: '_mediaItem' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _formLayout = {
    large: '_breakPoint',
    medium: '_breakPoint',
    small: '_breakPoint',
};
var _formTemplate = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_field',
    deletedFields: '_field',
    steps: '_step',
    rules: '_v2Rule',
    submitSettings: '_submitSettings',
};
var _functionsShopPriceSpiConfig = {
    shopNumber: 'google.protobuf.DoubleValue',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getAllAppsByPropertyRequest = {};
var _getAllAppsByPropertyResponse = {};
var _getAllAppsResponse = { dateCreated: 'google.protobuf.Timestamp' };
var _getAppByVersionRequest = {};
var _getAppInfoResponse = {
    dateCreated: 'google.protobuf.Timestamp',
    components: '_component',
};
var _getAppRequest = {};
var _getAppResponse = {
    dateCreated: 'google.protobuf.Timestamp',
    data: '_appData',
};
var _getAppsByAppNameRequest = {};
var _getAppsByAppNameResponse = { apps: '_getAppInfoResponse' };
var _getAppsByEmailRequest = {};
var _getAppsByEmailResponse = { apps: '_getAppInfoResponse' };
var _getAppSecretRequest = {};
var _getAppSecretResponse = {};
var _getAppServerAuthRequest = {};
var _getAppServerAuthResponse = {};
var _getAppsInfoRequest = {};
var _getAppsInfoResponse = { apps: '_getAppInfoResponse' };
var _getAppSnapshotResponse = {
    dateCreated: 'google.protobuf.Timestamp',
    components: '_component',
};
var _getAppsRequest = {};
var _getAppsResponse = { apps: '_getAllAppsResponse' };
var _getDeveloperAppsRequest = {};
var _getDeveloperAppsResponse = { apps: '_getAppInfoResponse' };
var _group = { items: '_itemLayout' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _inlineElement = {
    style: 'Map#_styleItem',
    data: 'Map#_dataItem',
    elements: 'Map#_elementItem',
    presets: 'Map#_presetItem',
    cssCustomProperties: 'Map#_cssCustomPropertyItem',
};
var _inputField = {
    stringOptions: '__String',
    numberOptions: '_inputField_Number',
    booleanOptions: '__Boolean',
    arrayOptions: '__Array',
    objectOptions: '__Object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
    multilineAddressOptions: '_address',
    schedulingOptions: '_scheduling',
    addressOptions: '_address',
};
var _inputField_Number = {
    numberInputOptions: '_numberInput',
    ratingInputOptions: '_ratingInput',
    validation: '_numberType',
};
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemLayout = { group: '_group' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _layoutData = {
    backgroundImage: '_backgroundImage',
    backdropImage: '_backgroundImage',
};
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _mediaItem = { image: '_commonImage' };
var _messageContainingTranslatables = {
    innerTranslatableRichContent: '_richContent',
};
var _meteredBilling = {
    monthlyBaseFee: 'DOUBLE',
    additionalCharges: 'google.protobuf.DoubleValue',
};
var _multilingualTranslationSchema = { referenceData: '_schema' };
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    layoutData: '_layoutData',
    nodes: '_node',
};
var _numberInput = {
    default: 'google.protobuf.DoubleValue',
    description: '_richContent',
    media: '_mediaItem',
};
var _numberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _objectField = {
    objectOptions: '_objectOptions',
    arrayOptions: '_arrayOptions',
};
var _objectOptions = { fields: '_objectField' };
var _objectType = { properties: 'Map#_propertiesType' };
var _orCondition = { conditions: '_conditionNode' };
var _packageDimension = {
    width: 'DOUBLE',
    length: 'DOUBLE',
    height: 'google.protobuf.DoubleValue',
};
var _packageType = { dimension: '_packageDimension', image: '_image' };
var _payment = {
    checkboxGroupOptions: '_productCheckboxGroup',
    donationInputOptions: '_donationInput',
    paymentInputOptions: '_paymentInput',
    fixedPaymentOptions: '_fixedPayment',
};
var _paymentInput = {
    default: 'google.protobuf.DoubleValue',
    description: '_richContent',
    media: '_mediaItem',
};
var _phoneInput = { description: '_richContent', media: '_mediaItem' };
var _plan = { billing: '_billing' };
var _pluginConfig = { startingEnforcementDate: 'google.protobuf.Timestamp' };
var _poll = { image: '_media', options: '_pollOption' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _pollOption = { image: '_media' };
var _predefinedExpectedInput = {
    configuration: '_predefinedExpectedInputConfiguration',
};
var _predefinedExpectedInputConfiguration = {
    textInput: '_adminConfigurableTextInput',
};
var _presetEditorPresence = { wixMediaThumbnail: '_wixCommonImage' };
var _presetElementDefaults = { elements: 'Map#_presetInnerElementDefaults' };
var _presetInnerElementDefaults = {
    elements: 'Map#_presetInnerElementDefaults',
};
var _presetItem = {
    styleDefaults: '_presetStyleDefaults',
    styleOverrides: '_breakpointPresetStyleOverrides',
    presetDefaults: '_presetElementDefaults',
};
var _presetStyleDefaults = { elements: 'Map#_elementStyleDefaults' };
var _presetStyleOverrides = { elements: 'Map#_elementStyleOverrides' };
var _pricingModel = { plans: '_plan' };
var _productCheckboxGroup = {
    description: '_richContent',
    options: '_productCheckboxGroupOption',
    media: '_mediaItem',
};
var _productCheckboxGroupOption = { media: '_mediaItem' };
var _propertiesType = {
    numberOptions: '_numberType',
    arrayOptions: '_arrayType',
};
var _radioGroup = { description: '_richContent', media: '_mediaItem' };
var _ratingInput = { description: '_richContent', media: '_mediaItem' };
var _refElement = {
    resolvedElement: '_inlineElement',
    elements: 'Map#_refInnerElementDefaults',
};
var _refInnerElementDefaults = { elements: 'Map#_refInnerElementDefaults' };
var _richContent = { nodes: '_node', metadata: '_v1Metadata' };
var _richContentOptions = { richContent: '_richContent' };
var _scheduling = { appointmentOptions: '_appointment' };
var _schema = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: 'Map#_v1SchemaField',
};
var _schemaGroup = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _setAppNamespaceRequest = {};
var _setAppNamespaceResponse = {};
var _shippingLabelCarrierSpiConfig = { packageTypes: '_packageType' };
var _shippingProviderConfig = { shippingPrice: 'DOUBLE' };
var _signature = { description: '_richContent', media: '_mediaItem' };
var _step = { layout: '_formLayout' };
var _studioWidgetComponentData = {
    widgetDisplay: '_widgetDisplay',
    editorPresence: '_editorPresence',
};
var _styleItem = { number: '_cssNumber' };
var _submitSettings = { thankYouMessageOptions: '_thankYouMessageOptions' };
var _tags = {
    description: '_richContent',
    options: '_tagsOption',
    media: '_mediaItem',
};
var _tagsOption = { media: '_mediaItem' };
var _textInput = { description: '_richContent', media: '_mediaItem' };
var _thankYouMessageOptions = { richContent: '_richContent' };
var _timeInput = { description: '_richContent', media: '_mediaItem' };
var _updateAppJsonRequest = {};
var _updateAppPropertyRequest = {};
var _updateAppPropertyResponse = {};
var _updateWixAppRequest = {};
var _v1Metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _v1SchemaField = { index: 'google.protobuf.DoubleValue' };
var _v2Rule = { expression: '_conditionNode' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _widgetComponentData = { widgetDisplay: '_widgetDisplay' };
var _widgetDisplay = { price: 'google.protobuf.FloatValue' };
var _widgetOutOfIframeComponentData = { widgetData: '_widgetComponentData' };
var _wixCommonImage = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _wixFile = {
    fileUploadOptions: '_fileUpload',
    signatureOptions: '_signature',
};
function resolveComWixpressAppserviceApiAppsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-service-webapp',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
            {
                srcPath: '/app-service-webapp',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
            {
                srcPath: '/app-service-webapp',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
            {
                srcPath: '/app-service-webapp',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-service',
                destPath: '/api',
            },
            {
                srcPath: '/_api/app-service-webapp',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates an app given name, as a side effect populates two kafka KV stores with the newly created app's secret and webhook secret
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.CreateApp(), and will be removed on 2024-02-01.
 */
export function create(payload) {
    var _a = serializer(_createAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAppResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.Create',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/**
 * Internal API (used by WoW projects) that does what the name suggests
 * This api requires a signature to be present in the request
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.QueryApp(), and will be removed on 2024-02-01.
 */
export function getAppsByAppName(payload) {
    var _a = serializer(_getAppsByAppNameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsByAppNameResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getAppInfoResponse: _getAppInfoResponse,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getAppsByAppName(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppsByAppName',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/app-name',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/app-name',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppsByAppName.fromReq = fromReq;
    __getAppsByAppName.__isAmbassador = true;
    return __getAppsByAppName;
}
/**
 * Gets the app's current snapshot in our databases, without taking into account any specific version
 * This is most likely NOT what you need, see getAppByVersion
 * @deprecated Will be removed on 2024-02-01.
 */
export function getAppSnapshot(payload) {
    var _a = serializer(_getAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSnapshotResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getAppSnapshot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppSnapshot',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/{appId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppSnapshot.fromReq = fromReq;
    __getAppSnapshot.__isAmbassador = true;
    return __getAppSnapshot;
}
/** Retrieves an app's data in a specific version, recommended way of getting an app's data */
export function getAppByVersion(payload) {
    var _a = serializer(_getAppByVersionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appData: _appData,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _billing: _billing,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _meteredBilling: _meteredBilling,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _plan: _plan,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _pricingModel: _pricingModel,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getAppByVersion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppByVersion',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/version/{version}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/{appId}/version/{version}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppByVersion.fromReq = fromReq;
    __getAppByVersion.__isAmbassador = true;
    return __getAppByVersion;
}
/**
 * Get's all the apps that belong to the current developer
 * All apps that are under the team that the developer is included in will return
 * @deprecated It has been replaced with wix.devcenter.myapps.v1.QueryMyApps(), and will be removed on 2024-08-01.
 */
export function getDeveloperApps(payload) {
    var _a = serializer(_getDeveloperAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeveloperAppsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getAppInfoResponse: _getAppInfoResponse,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getDeveloperApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetDeveloperApps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getDeveloperApps.fromReq = fromReq;
    __getDeveloperApps.__isAmbassador = true;
    return __getDeveloperApps;
}
/**
 * Change's the value of the wixapp flag on the app
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.UpdateApp(), and will be removed on 2024-02-01.
 */
export function updateWixApp(payload) {
    var _a = serializer(_updateWixAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSnapshotResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __updateWixApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.UpdateWixApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/wix-app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateWixApp.fromReq = fromReq;
    __updateWixApp.__isAmbassador = true;
    return __updateWixApp;
}
/**
 * Retrieve's the app's secrets, checks if the user is a part of the app's team OR server signature with
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.GetApp(), and will be removed on 2024-02-01.
 */
export function getAppSecret(payload) {
    var _a = serializer(_getAppSecretRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSecretResponse, {}).fromJSON;
    function __getAppSecret(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppSecret',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/secret',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/{appId}/secret',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppSecret.fromReq = fromReq;
    __getAppSecret.__isAmbassador = true;
    return __getAppSecret;
}
/**
 * Retrieve's the app's secret and if it is a Wix owned TPA, checks if the user is a part of the app's team OR server signature with
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.GetApp(), and will be removed on 2024-02-01.
 */
export function getAppServerAuth(payload) {
    var _a = serializer(_getAppServerAuthRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppServerAuthResponse, {}).fromJSON;
    function __getAppServerAuth(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppServerAuth',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/server-auth',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/{appId}/server-auth',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppServerAuth.fromReq = fromReq;
    __getAppServerAuth.__isAmbassador = true;
    return __getAppServerAuth;
}
/**
 * Bulk get appInfo
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.GetApp(), and will be removed on 2024-02-01.
 */
export function getAppsInfo(payload) {
    var _a = serializer(_getAppsInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsInfoResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getAppInfoResponse: _getAppInfoResponse,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getAppsInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppsInfo',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps-info',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps-info',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppsInfo.fromReq = fromReq;
    __getAppsInfo.__isAmbassador = true;
    return __getAppsInfo;
}
/**
 * Get all apps from app service, pagniated
 * Requires a signature to be passed as param (contact us to learn more)
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.QueryApp(), and will be removed on 2024-02-01.
 */
export function getApps(payload) {
    var _a = serializer(_getAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsResponse, {
        _getAllAppsResponse: _getAllAppsResponse,
    }).fromJSON;
    function __getApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetApps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/allapps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/allapps',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getApps.fromReq = fromReq;
    __getApps.__isAmbassador = true;
    return __getApps;
}
/**
 * Soft delete an app (will not return in getDeveloperApps)
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.UpdateApp(), and will be removed on 2024-02-01.
 */
export function archiveApp(payload) {
    var _a = serializer(_archiveAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSnapshotResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __archiveApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'PUT',
            methodFqn: 'com.wixpress.appservice.api.Apps.ArchiveApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveApp.fromReq = fromReq;
    __archiveApp.__isAmbassador = true;
    return __archiveApp;
}
/**
 * Retrieve's all apps that belong to a user with specific email
 * Requires a signature to be passed as param (contact us to learn more)
 */
export function getAppsByEmail(payload) {
    var _a = serializer(_getAppsByEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsByEmailResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getAppInfoResponse: _getAppInfoResponse,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getAppsByEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAppsByEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/user-email/{email}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/user-email/{email}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getAppsByEmail.fromReq = fromReq;
    __getAppsByEmail.__isAmbassador = true;
    return __getAppsByEmail;
}
/** Update an app's old json representation (for apps that are migrated from old dev center) */
export function updateAppJson(payload) {
    var _a = serializer(_updateAppJsonRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSnapshotResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Function: __Function,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _address: _address,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _arrayItems: _arrayItems,
        _arrayOptions: _arrayOptions,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _breakPoint: _breakPoint,
        _breakpointPresetStyleOverrides: _breakpointPresetStyleOverrides,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _collection: _collection,
        _commonImage: _commonImage,
        _component: _component,
        _componentData: _componentData,
        _componentsMultilineAddress: _componentsMultilineAddress,
        _conditionNode: _conditionNode,
        _cssCustomPropertyItem: _cssCustomPropertyItem,
        _cssNumber: _cssNumber,
        _dataComponent: _dataComponent,
        _dataComponentField: _dataComponentField,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _elementStyleOverrides: _elementStyleOverrides,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _focalPoint: _focalPoint,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputField_Number: _inputField_Number,
        _item: _item,
        _itemImage: _itemImage,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectField: _objectField,
        _objectOptions: _objectOptions,
        _objectType: _objectType,
        _orCondition: _orCondition,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetElementDefaults: _presetElementDefaults,
        _presetInnerElementDefaults: _presetInnerElementDefaults,
        _presetItem: _presetItem,
        _presetStyleDefaults: _presetStyleDefaults,
        _presetStyleOverrides: _presetStyleOverrides,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _refElement: _refElement,
        _refInnerElementDefaults: _refInnerElementDefaults,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _scheduling: _scheduling,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _step: _step,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _styleItem: _styleItem,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixCommonImage: _wixCommonImage,
        _wixFile: _wixFile,
    }).fromJSON;
    function __updateAppJson(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.UpdateAppJson',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/update-json',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAppJson.fromReq = fromReq;
    __updateAppJson.__isAmbassador = true;
    return __updateAppJson;
}
/**
 * Internal API, hard deletes an app (changes appId in all DB tables)
 * Deprecated. Use UpdateApp and update the Archived status
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.UpdateApp(), and will be removed on 2024-02-01.
 */
export function deleteAppDeprecated(payload) {
    var _a = serializer(_deleteAppDeprecatedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAppDeprecatedResponse, {}).fromJSON;
    function __deleteAppDeprecated(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'PUT',
            methodFqn: 'com.wixpress.appservice.api.Apps.DeleteAppDeprecated',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAppDeprecated.fromReq = fromReq;
    __deleteAppDeprecated.__isAmbassador = true;
    return __deleteAppDeprecated;
}
/** Given a list (of no more than 100) of appIds owned by one of the QA users, delete them */
export function bulkDeleteAutomationApps(payload) {
    var _a = serializer(_bulkDeleteAutomationAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteAutomationAppsResponse, {}).fromJSON;
    function __bulkDeleteAutomationApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.bulkDeleteAutomationApps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/bulk-delete-automation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteAutomationApps.fromReq = fromReq;
    __bulkDeleteAutomationApps.__isAmbassador = true;
    return __bulkDeleteAutomationApps;
}
/**
 * Update some app's property
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.UpdateApp(), and will be removed on 2024-02-01.
 */
export function updateAppProperty(payload) {
    var _a = serializer(_updateAppPropertyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAppPropertyResponse, {}).fromJSON;
    function __updateAppProperty(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.UpdateAppProperty',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/{appId}/update-app-property',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAppProperty.fromReq = fromReq;
    __updateAppProperty.__isAmbassador = true;
    return __updateAppProperty;
}
/**
 * Return list of all apps
 * filtered by apps that have the requested property and value
 * returns a list of app ids.
 * this API is limited to 100 apps. please use pagination.
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.QueryApp(), and will be removed on 2024-02-01.
 */
export function getAllAppsByProperty(payload) {
    var _a = serializer(_getAllAppsByPropertyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAllAppsByPropertyResponse, {}).fromJSON;
    function __getAllAppsByProperty(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.Apps.GetAllAppsByProperty',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/v1/apps/get-all-apps-by-property',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAppserviceApiAppsUrl({
                        protoPath: '/v1/apps/get-all-apps-by-property',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData, true),
                },
            ],
        };
        return metadata;
    }
    __getAllAppsByProperty.fromReq = fromReq;
    __getAllAppsByProperty.__isAmbassador = true;
    return __getAllAppsByProperty;
}
/**
 * Update the namespace for this app
 * Note that once this field is set it cannot be changed
 * This API is available to app owner and app market employees
 * @deprecated It has been replaced with com.wixpress.devcenter.apps.v1.SetNamespace(), and will be removed on 2024-02-01.
 */
export function setAppNamespace(payload) {
    var _a = serializer(_setAppNamespaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setAppNamespaceResponse, {}).fromJSON;
    function __setAppNamespace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_old',
            method: 'POST',
            methodFqn: 'com.wixpress.appservice.api.Apps.SetAppNamespace',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAppserviceApiAppsUrl({
                protoPath: '/api/v1/apps/set-app-namespace',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setAppNamespace.fromReq = fromReq;
    __setAppNamespace.__isAmbassador = true;
    return __setAppNamespace;
}
//# sourceMappingURL=http.impl.js.map